import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { ReferralApi } from "../../../services";

type UseReferralStatusOptions = {
  onSuccess?: (data: boolean) => void;
};

export const useReferralStatus = (options?: UseReferralStatusOptions) => {
  return useQuery(QUERY_KEYS.referralStatus, () => ReferralApi.init().getStatus(), {
    initialData: null,
    onSuccess: options?.onSuccess,
  });
};
